// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__7IXMU"};